/* ============================================================================
   nuud US — sticky buy bar
   ----------------------------------------------------------------------------
   Mirrors the buy box's current selection and submits the same form.

   Two things worth knowing:

   1. The reveal is driven by IntersectionObserver watching the buy box, not by
      a scroll handler wrapped in requestAnimationFrame. rAF does not fire in a
      backgrounded tab, which makes an rAF-gated bar look broken under
      automated testing and in background tabs.

   2. The bar toggles `is-visible`, and the CSS in section-sticky.css keys off
      exactly that class. If you rename one, rename both.
   ========================================================================= */
(function () {
  'use strict';

  function boot() {
    var bar = document.querySelector('[data-sticky-bar]');
    var box = document.querySelector('[data-buy-box]');
    if (!bar || !box) return;

    var els = {
      title: bar.querySelector('[data-sticky-title]'),
      sub:   bar.querySelector('[data-sticky-sub]'),
      image: bar.querySelector('[data-sticky-image]'),
      cta:   bar.querySelector('[data-sticky-cta]')
    };

    bar.hidden = false;
    document.body.classList.add('has-sticky-bar');

    /* ------------------------------------------------------------- reveal */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Show only once the buy box has left upward, not when it is still
          // below the fold on first paint.
          var goneUp = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle('is-visible', goneUp);
        });
      }, { threshold: 0 });
      io.observe(box);
    } else {
      bar.classList.add('is-visible');
    }

    /* ------------------------------------------------------------- mirror */
    function sync(detail) {
      if (!detail || !detail.pack) return;
      var pack = detail.pack;
      if (els.sub)   els.sub.textContent = pack.name + ' · ' + pack.contents;
      if (els.image && pack.image) { els.image.src = pack.image; }

      var live = box.querySelector('[data-submit]');
      if (els.cta && live) {
        els.cta.textContent = live.textContent;
        els.cta.disabled = live.disabled;
      }
    }

    document.addEventListener('buybox:change', function (e) { sync(e.detail); });

    // Both scripts are deferred, so buy-box.js has already run its first render
    // and fired `buybox:change` before this listener existed. Without this the
    // bar shows its placeholder title and an EMPTY button until the visitor
    // touches the pack picker. Read the state buy-box.js parked on the element.
    sync(box.buyboxState);

    // The bar has no form of its own: it submits the buy box's, so there is
    // exactly one source of truth for what goes in the cart.
    if (els.cta) {
      els.cta.addEventListener('click', function () {
        var form = box.querySelector('[data-buy-form]');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
